<template>
  <div class="film">
    <div class="image">
      <video width="100%" :poster="'/images/movies/' + movie.image_url" controls>
        <source :src="'/images/movies/' + movie.video_url" type="video/mp4">
        Your browser does not support the video tag.
      </video>
    </div>
    <div class="caption">
      <h2>{{ movie.title }}</h2>
      <div v-html="movie.description"></div>
    </div>
  </div>
</template>

<script>
 export default{
  name:'movie-item',
  props: {
    movie: Object
  }
 }
</script>
